import type { ValueOf } from 'type-fest';

export const FIREBASE_ERROR_CODE = {
  WRONG_PASSWORD: 'auth/wrong-password',
  EMAIL_NOT_FOUND: 'auth/user-not-found',
  USER_DISABLED: 'auth/user-disabled',
} as const;

export type FirebaseErrorCode = ValueOf<typeof FIREBASE_ERROR_CODE>;

export class ErrorFirebaseDTO {
  code!: FirebaseErrorCode;
  customData: unknown;
  name!: 'FirebaseError';

  constructor(opts?: Record<string, any>) {
    if (opts) Object.keys(this).forEach((key) => (this[key] = opts[key]));
  }
}
